'use client';

import { Link } from '@inato/ui';
import { useCallback, useState } from 'react';

import { ContactUsModal } from './AppLayout/ContactUsModal';

interface FooterItem {
  text: string;
  link?: string;
}

const FOOTER_ITEMS: ReadonlyArray<FooterItem> = [
  {
    text: `© ${new Date().getFullYear()} Inato. All Rights Reserved`,
  },
  {
    text: 'Corporate Website',
    link: 'https://inato.com/',
  },
  {
    text: 'Privacy Policy',
    link: 'https://inato.com/privacy-policy/',
  },
  {
    text: 'Terms & Conditions',
    link: 'https://inato.com/terms-of-use/',
  },
  {
    text: 'Cookie Policy',
    link: 'https://inato.com/cookie-policy/',
  },
];

export const Footer = ({ className }: { className?: string }) => (
  <footer className={className}>
    <ul className="m-zero p-zero flex flex-wrap">
      {FOOTER_ITEMS.map(({ text, link }, index) => (
        <li className="inline whitespace-nowrap" key={text}>
          {index !== 0 && <span className="mx-xs">·</span>}
          {link ? (
            <Link href={link} target="_blank">
              {text}
            </Link>
          ) : (
            text
          )}
        </li>
      ))}
      <li className="desktop:ml-auto inline whitespace-nowrap">
        <span className="mx-xs desktop:hidden">·</span>
        <ContactUsLink />
      </li>
    </ul>
  </footer>
);

const ContactUsLink = ({ className }: { className?: string }) => {
  const [isModalOpened, setIsModalOpenened] = useState(false);

  const handleClick = useCallback(() => {
    setIsModalOpenened(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsModalOpenened(false);
  }, []);

  return (
    <>
      <Link href="#" onClick={handleClick} className={className}>
        Contact us
      </Link>
      {isModalOpened && <ContactUsModal onClose={handleClose} />}
    </>
  );
};
